import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import styled, { css } from 'styled-components';

export type CenteredAxis = 'horizontal' | 'vertical' | 'both';

export interface CenteredProps {
	axis?: CenteredAxis;
	children?: React.ReactNode;
	style?: {
		height: string | number;
	};
	css?: any;
}

function horizontal(axis: CenteredAxis): boolean {
	return axis !== 'vertical';
}

function vertical(axis: CenteredAxis): boolean {
	return axis !== 'horizontal';
}

const CenteredStyle = styled.div`
	display: flex;
	${({ axis = 'both' }: CenteredProps) =>
		horizontal(axis)
			? css`
					justify-content: center;
				`
			: ''}
	${({ axis = 'both' }: CenteredProps) =>
		vertical(axis)
			? css`
					align-items: center;
				`
			: ''};
`;

export const Centered: React.FC<CenteredProps> = ({ children, ...props }) => (
	<CenteredStyle {...props}>{children}</CenteredStyle>
);
